import * as React from 'react'
import {Nullable} from '../../../../../app/TypeHelpers'
import {BlockSpacer} from '../../../../../styledComponents/ResponsiveConvenience'
import NatResidentApplicationDetailConfirmItem from '../../common/resident/NatResidentApplicationDetailConfirmItem'
import {APPLY_CATEGORY, USER_ATTRIBUTE, CHANGE_TYPE} from '../../../../../CodeMaster'
import {convertToRoomNumberForResident} from '../../../../common/util/Natutil'
import {
    NatResidentLoginInfoSessionStorageHelper,
    ResidentLoginInfoSessionStorageKey
} from '../../../../common/authentication/NatResidentLoginInfoSessionStorageHelper'
import {getFormattedDate} from '../helper/NatBikeParkingUseChangeApplyHelper'

interface Props {
    applicantFamilyName: Nullable<string>
    applicantFirstName: Nullable<string>
    useArea: Nullable<string>
    changeType: Nullable<string>
    changeStartDate: Nullable<string>
    changeEndDate: Nullable<string>
    userFamilyName: Nullable<string>
    userFirstName: Nullable<string>
    userAttribute: Nullable<string>
    ownerFamilyName: Nullable<string>
    ownerFirstName: Nullable<string>
    bikeType: Nullable<string>
    bikeName: Nullable<string>
    bikeRegistrationNumber: Nullable<string>
    engineSize: Nullable<string>
    applyFlag?: boolean
}

const NatResidentBikeParkingUseChangeApplyConfirm = ({applyFlag = true, ...otherProps}: Props) => {
    const {
        applicantFamilyName, applicantFirstName, useArea, changeType,
        changeStartDate, changeEndDate, userFamilyName, userFirstName,
        userAttribute, ownerFamilyName, ownerFirstName, bikeType, bikeName,
        bikeRegistrationNumber, engineSize
    } = otherProps

    const applyCategoryLabel = APPLY_CATEGORY.BIKE_CHANGE.label

    const changeTypeLabel = (changeType) ?
        CHANGE_TYPE.codeToEnumConstants(changeType).label : ''

    const changeStartDateLabel = (changeStartDate) ?
        getFormattedDate(changeStartDate) : ''

    const changeEndDateLabel = (changeEndDate) ?
        getFormattedDate(changeEndDate) : ''

    const userAttributeLabel = (userAttribute) ?
        USER_ATTRIBUTE.codeToEnumConstants(userAttribute).label : ''

    const applicantRoom = NatResidentLoginInfoSessionStorageHelper
            .getStringItemOrNull(ResidentLoginInfoSessionStorageKey.SELECTED_CONDOMINIUM_NAME) + '　' +
        NatResidentLoginInfoSessionStorageHelper
            .getStringItemOrNull(ResidentLoginInfoSessionStorageKey.SELECTED_RIDGENAME) + ' ' +
        convertToRoomNumberForResident(
            NatResidentLoginInfoSessionStorageHelper
                .getStringItemOrNull(ResidentLoginInfoSessionStorageKey.SELECTED_ROOM_NUMBER)
        )

    return (<>
        {applyFlag === true &&
            <>
                <NatResidentApplicationDetailConfirmItem
                    title={'申請区分'}
                    items={[applyCategoryLabel]}
                />
                <BlockSpacer height={'5px'}/>
                <NatResidentApplicationDetailConfirmItem
                    title={'申請者'}
                    items={[applicantRoom, `${applicantFamilyName} ${applicantFirstName}`]}
                />
            </>
        }
        <BlockSpacer height={'5px'}/>
        <NatResidentApplicationDetailConfirmItem
            title={'使用区画'}
            items={[`${useArea}`]}
        />
        <BlockSpacer height={'5px'}/>
        <NatResidentApplicationDetailConfirmItem
            title={'変更態様'}
            items={[`${changeTypeLabel}`]}
        />
        <BlockSpacer height={'5px'}/>
        {(changeType === CHANGE_TYPE.TEMPORARY.value) ?
            <>
                <NatResidentApplicationDetailConfirmItem
                    title={'変更日'}
                    items={[
                        '開始日: ' + `${changeStartDateLabel}`,
                        '終了日: ' + `${changeEndDateLabel}`
                    ]}
                />
            </>:
            <>
                <NatResidentApplicationDetailConfirmItem
                    title={'変更日'}
                    items={[
                        '開始日: ' + `${changeStartDateLabel}`
                    ]}
                />
            </>
        }
        <BlockSpacer height={'5px'}/>
        <NatResidentApplicationDetailConfirmItem
            title={'使用者'}
            items={[`${userFamilyName} ${userFirstName}` + '（' + `${userAttributeLabel}` + '）']}
        />
        <BlockSpacer height={'5px'}/>
        <NatResidentApplicationDetailConfirmItem
            title={'バイク情報'}
            items={[
                '所有者：' + `${ownerFamilyName} ${ownerFirstName}`,
                '種別：' + `${bikeType}`,
                '車名：' + `${bikeName}`,
                '標識番号：' + `${bikeRegistrationNumber}`,
                '排気量：' + `${engineSize}cc`
            ]}
        />
    </>)
}

NatResidentBikeParkingUseChangeApplyConfirm.displayName = 'NatResidentBikeParkingUseChangeApplyConfirm'
export default NatResidentBikeParkingUseChangeApplyConfirm